import React from 'react';
import { History } from 'history';
import { Input, InputNumber, InputMultiline, InputSelect, Layout, InputFile, InputSwitch } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './quizquestion-model';  //editable..
import QuizanswerList from '../quizanswer/quizanswer-list.component';

interface IProps { 
    history: History;
    root?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class QuizquestionDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }
    
    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            
            <BaseDelete history={this.props.history} 
                model={Model} onLoad={this.onLoad} disableCard>              
                
                <Layout history={this.props.history} content={[
                    {caption: 'Details', child: 
                    <>
                        <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                        <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                        <Input name='title' label='Title' value={this.state.datarow.title} readOnly/>
                        <InputMultiline name='content' label='Content' value={this.state.datarow.content} readOnly/>
                        <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' readOnly/>
                        <InputNumber name='seq' label='Seq' value={this.state.datarow.seq} readOnly/>
                        <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} readOnly/>
                        
                    </>
                    },

                    {caption: 'Quizquestion Options', child: 
                    this.state.datarow.id > 0 && this.props.history &&
                        <QuizanswerList history={this.props.history} root={this.props.root} questionId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>                            
                    },
                    ]}

                />
                        
            </BaseDelete>
        );
    }
}